<template>
    <InformationPage
        title="Privacy Policy"
        description="Learn how we collect, use, and protect your personal information."
        :breadcrumb="[
            { icon: 'i-heroicons-home', label: 'Home', to: '/' },
            { label: 'Privacy Policy' }
        ]"
    >
    <div class="prose">
        <p class="text-lg text-gray-600 dark:text-gray-400">
            Last updated: {{ new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) }}
        </p>

        <h2>Information We Collect</h2>
        <p>We collect information you provide directly to us, including your name, email address, shipping address, and payment information when you create an account or make a purchase.</p>

        <h2>How We Use Your Information</h2>
        <p>We use the information we collect to process your orders, communicate with you about your purchases, improve our services, and send you promotional content (with your consent).</p>

        <h2>Data Security</h2>
        <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>

        <h2>Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. You can manage your preferences in your account settings or contact us directly.</p>

        <h2>Cookies</h2>
        <p>We use cookies to enhance your browsing experience and analyze site traffic. You can control cookie preferences through your browser settings.</p>

        <h2>Contact Us</h2>
        <p>If you have questions about this Privacy Policy, please contact us at privacy@example.com.</p>
    </div>
    <template #aside>
        <Timeline />
    </template>
</InformationPage>
</template>
<script setup lang="ts">
import InformationPage from '~/components/templates/InformationPage.vue';
import Timeline from '~/components/organisms/Timeline.vue';

definePageMeta({
    layout: 'information',
})
</script>